import { useState } from "react";

interface UseRefundSangjoArgs {
  totalProductPrice?: string;
  totalUserPaymentPrice?: string;
  totalPaymentDates?: string;
}

export const useRefundSangjoPrice = ({
  totalProductPrice,
  totalUserPaymentPrice,
  totalPaymentDates,
}: UseRefundSangjoArgs) => {
  const [상조환급금, set_상조환급금] = useState<number | undefined>(undefined);
  const reset_상조환급금 = () => set_상조환급금(undefined);

  const chage_상조환급금 = () => {
    if (totalProductPrice && totalUserPaymentPrice && totalPaymentDates) {
      const result = calculateCancelSangjoProduct({
        상품가격: Number(totalProductPrice),
        납입금_누계: Number(totalUserPaymentPrice),
      });

      set_상조환급금(result);
    }
  };

  const calculateCancelSangjoProduct = ({
    납입금_누계,
    상품가격,
  }: {
    납입금_누계: number;
    상품가격: number;
  }) => {
    const 모집수당 = 상품가격 >= 5_000_000 ? 500_000 : 상품가격 * 0.1;
    const 모집수당_공재액 = 모집수당 * 0.75 + 모집수당 * 0.25 * (납입금_누계 / 상품가격);
    const 관리비_누계 = 납입금_누계 * 0.05;

    const 해약환급금 = 납입금_누계 - 모집수당_공재액 - 관리비_누계;

    return 해약환급금 > 0 ? Math.floor(해약환급금 / 10) * 10 : 0;
  };

  return {
    상조환급금,
    reset_상조환급금,
    chage_상조환급금,
  };
};
